import style from "./Dialog.module.css";

const Dialog = (props) => {
  return (
    <div
      className={`${style.container} ${props.show && style.show} ${
        props.variants ? props.variants.map((i) => style[i]).join(" ") : null
      }`}
    >
      <div className={style.background} onClick={props.onClose}></div>
      <div className={style.dialog}>
        <h2>{props.title}</h2>
        <div className={style.content}>
        {props.children}
        </div>
      </div>
    </div>
  );
};

export default Dialog;
